import React from 'react';

const RightContent = ({ gameSyncData, playerId }) => {

 const isTeamGame = gameSyncData.gameMode === 'team';

  let displayScore = 0;

  if (isTeamGame) {
    // Find player's team
    const teams = gameSyncData.teams || {};
    const teamScores = gameSyncData.teamScores || {};
    const playerTeam = Object.keys(teams).find((teamName) =>
      teams[teamName].includes(playerId)
    );

    if (playerTeam) {
      displayScore = teamScores[playerTeam] || 0;
    } else {
      displayScore = 0;
    }
  } else {
    const player = gameSyncData.players.find((p) => p.id === playerId);
    displayScore = player?.score || 0;
  }



    return (
        <div className="flex flex-col items-center">
            <div className={`w-[4rem] h-[4rem] sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-36 lg:h-36 rounded-full bg-[#022E7E] flex items-center justify-center `}>
                <span className="text-[#FFCC21] text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-wide notranslate" translate="no">
                    {displayScore}
                </span>
            </div>

            <div className="w-full text-center mt-3 px-4 py-1 bg-[#022E7E] text-[#FFCC21] rounded-full text-base sm:text-lg font-semibold shadow-sm">
                Score
            </div>
        </div>
    );

};  

export default RightContent;
